export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8555.25d0db6f.jpg";